import * as React from "react";

function SvgPeopleConf(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" {...props}>
      <g data-name="Grupo de m\xE1scara 30">
        <path
          d="M10.723 12.099a6.675 6.675 0 00-1.4-.749 3.579 3.579 0 001.161-2.36 5.292 5.292 0 016.711-.549.702.702 0 00.8-1.153 6.682 6.682 0 00-1.4-.749 3.586 3.586 0 10-4.827-.008q-.147.057-.293.12a6.676 6.676 0 00-1.238.711 3.585 3.585 0 10-5.752 3.974A6.762 6.762 0 00.4 15.544 2.11 2.11 0 002.411 18.3h6.117a.703.703 0 000-1.406H2.411a.7.7 0 01-.669-.919 5.425 5.425 0 015.158-3.67 5.258 5.258 0 013.023.948.702.702 0 10.8-1.153zm3.464-10.393a2.18 2.18 0 11-2.179 2.18 2.182 2.182 0 012.179-2.18zM6.911 6.518a2.18 2.18 0 11-2.179 2.18 2.182 2.182 0 012.179-2.18z"
          strokeWidth={0.4}
          stroke="currentColor"
          fill="currentColor"
        />
        <g data-name="Grupo de m\xE1scara 31">
          <g data-name="Grupo 252">
            <g data-name="Grupo 251">
              <path
                d="M19.001 15.062h-.469a3.047 3.047 0 00-.579-1.4l.332-.332a.438.438 0 00-.619-.619l-.332.332a3.047 3.047 0 00-1.4-.579v-.465a.438.438 0 10-.875 0v.469a3.047 3.047 0 00-1.4.579l-.324-.332a.438.438 0 00-.619.619l.332.332a3.047 3.047 0 00-.579 1.4h-.468a.438.438 0 000 .875h.469a3.047 3.047 0 00.579 1.4l-.332.332a.438.438 0 00.619.619l.332-.332a3.047 3.047 0 001.4.579v.469a.438.438 0 10.875 0v-.478a3.047 3.047 0 001.4-.579l.368.374a.438.438 0 00.619-.619l-.379-.374a3.047 3.047 0 00.579-1.4h.471a.438.438 0 000-.875zm-3.5 2.625a2.181 2.181 0 01-1.544-.64 2.184 2.184 0 010-3.089 2.184 2.184 0 013.089 0 2.186 2.186 0 01-1.545 3.729z"
                data-name="Caminho 99"
                strokeWidth={0.8}
                stroke="currentColor"
                fill="currentColor"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgPeopleConf;

